import React, { useState } from 'react';
import i18n from 'i18next';
import { generateLoginUrl } from '../../utils/api';
import './styles.scss';
import { trackMixpanelEvent } from '../../utils';
import { MIX_PANEL_EVENTS } from '../../constants/mixpanel';

const { ENGAGEMENT_SURVEY } = MIX_PANEL_EVENTS;

let didInit = false;

const LoginRedirectButton = () => {
    const [isShow, setIsShow] = useState(false);
    const loginUrl = generateLoginUrl(false);

    function redirectToLogin() {
        trackMixpanelEvent({
            eventName: ENGAGEMENT_SURVEY.ENGAGEMENT_SURVEY_CLICK_LOGIN
        });

        window.location.assign(loginUrl);
    }

    if (!didInit) {
        setTimeout(() => setIsShow(true), 500);

        didInit = true;
    }

    return (
        <div
            className={
                isShow
                    ? 'show-login'
                    : 'hide-login'
            } >
            <h3
                className='login-redirect-label' >
                {i18n.t('attuned_login_redirect_label')}
            </h3>
            <button
                onClick={ () => redirectToLogin() }
                className='login-redirect-button' >
                {i18n.t('attuned_login_redirect')}
            </button>
        </div>
    );
};

export default LoginRedirectButton;
